import React from "react";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { SubNavLink } from "./sub-nav-link";
import { ImageTeaser } from "./image-teaser";
import { type StandardTabProps } from "./data";
import { NavColumnLabel } from "./nav-column-label";

export function SubNav({ columns, teaser }: StandardTabProps) {
  const { theme } = useColorTheme();
  const borderColor = `brand.header.border.${theme}`;
  const gridColumns = (columns?.length ?? 0) + (teaser ? 1 : 0);

  return (
    <Box w="100%" maxW={{ base: "100%", xl: "container.page" }} mt="smaller" mx="auto" px={{ base: 0, xl: "biggest" }}>
      <SimpleGrid
        columns={{ base: 1, md: gridColumns }}
        templateColumns={{ base: "1", lg: `repeat(${gridColumns}, 1fr)` }}
        justifyItems="stretch"
        flex={1}
        gap={gridColumns < 4 ? "small" : "0"}
        w="100%"
      >
        {columns?.map((column, index) => (
          <Flex
            key={column.label}
            borderLeft="1px"
            borderBottom="1px"
            borderLeftColor={{ base: "transparent", lg: index === 0 ? "transparent" : borderColor }}
            borderBottomColor={{ base: index === columns.length - 1 ? "transparent" : borderColor, lg: "transparent" }}
            direction="column"
            flex={1}
            mt="big"
            px={{ base: "smaller", lg: "smallest", xl: "smaller" }}
            pb={{ base: "small", lg: "0" }}
          >
            <NavColumnLabel>{column.label}</NavColumnLabel>

            <Flex align="start" direction="column" w="100%">
              {column.items?.map((navItem) => (
                <SubNavLink key={navItem.label} aria-label={navItem.label} {...navItem} />
              ))}
            </Flex>
          </Flex>
        ))}

        {teaser && (
          <Flex
            direction="column"
            flex={1}
            pos="relative"
            pb={{ base: "small", lg: "0" }}
            maxW={{ base: "100%", lg: "244px" }}
          >
            <ImageTeaser {...teaser} />
          </Flex>
        )}
      </SimpleGrid>
    </Box>
  );
}
